import React from 'react';
import { history } from 'helpers/router';
import { LOGIN } from 'constants/routes';

import { t } from 'components/Translate';
import Icon from 'components/Icon';

import OnboardingScreen from './../Screen';
import styles from './../Onboarding.module.scss';

type Props = {
};

const EmailVerified: React.FC<Props> = () => (
  <div className={ styles.signupContainer }>
    <OnboardingScreen
      icon={ <Icon.Circled color="gray-shy" iconColor="black" name="mail" mark="success" size="x-large" /> }
      title={ t('onboarding.confirmation.email.title') }
      description={ t('onboarding.confirmation.email.description') }
      action={ t('common.action.login') }
      onClick={ () => history.push(LOGIN) }
    />
  </div>
);

export default EmailVerified;
